import RowGroup, { Row, Cell, HeadingCell, CaptionCell } from './RowGroup'
export { panelActionCellProps } from './RowGroup'

export default Object.assign(RowGroup, {
  Row,
  Cell,
  HeadingCell,
  CaptionCell,
})
